export default "__VITE_ASSET__C$8jvbVI__"